import debounce from "lodash/debounce";
import { Download } from "lucide-react";
import React, { useEffect, useRef, useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import Dropzone from "react-dropzone";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Label,
  Row,
  Spinner,
  UncontrolledDropdown,
} from "reactstrap";
import {
  compareResultData,
  fetchComparisonData,
  fetchPriceComparisonFileAPI,
  uploadPriceComparisonFileAPI,
} from "../../api/priceComparison";
import {
  Block,
  Button,
  DataTable,
  DataTableBody,
  DataTableHead,
  DataTableItem,
  DataTableRow,
  Icon,
  PaginationComponent,
  PreviewCard,
  TooltipComponent,
} from "../../components/Component";
import DateRangePicker from "../../components/DateRangePicker";
import Content from "../../layout/content/Content";
import { useUserInfo } from "../../layout/provider/Theme";
import { formatCurrency } from "../../utils";
import CostPlusEditModal from "./CostPlusEditModal";
import ViewStationCompareModal from "./ViewStationCompareModal";

const Index = () => {
  const { settingsData, handleUserInfo } = useUserInfo();
  const defaultValuesGlobal = {
    costPlus: settingsData?.find((item) => item.key === "cost_plus")?.value,
    distanceRadius: settingsData?.find((item) => item.key === "distance_radius")
      ?.value,
    stateFallback: settingsData?.find((item) => item.key === "state_fallback")
      ?.value,
    selectPetro: settingsData?.find((item) => item.key === "station")
      ?.value,
  };

  const [files, setFiles] = useState([]);
  const [data, setData] = useState([]);
  // const [tablesm, updateTableSm] = useState(false);
  const tablesm = false;
  const [onSearch, setonSearch] = useState(true);
  const [onSearchText, setSearchText] = useState("");
  // const [actionText, setActionText] = useState("");
  const actionText = "";
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(5);
  const [sort, setSortState] = useState("");
  const [loading, setLoading] = useState(false);
  const [uploadButtonLoading, setUploadButtonLoading] = useState(false);
  const [sortType, setSortType] = useState("ASC");
  const [modal, setModal] = useState(false);
  const [mutation, setMutation] = useState({});
  const [metadata, setMetadata] = useState({});
  const [selectedReport, setSelectedReport] = useState(null);
  const reportRef = useRef(null);
  const [metaDataComparisonState, setMetaDataComparisonState] = useState({});
  const [providedDates, setProvidedDates] = useState([]); // Initialize with empty array
  const [selectReportLoader, setSelectReportLoader] = useState(false);
  const [displayBlockPricingReportData, setDisplayBlockPricingReportData] =
    useState(false);
  const [displayBlockReportResult, setDisplayBlockReportResult] =
    useState(false);
  const [pricingCalendarLoading, setPricingCalendarLoading] = useState(false);
  const [isUploadingSelections, setIsUploadingSelections] = useState(false);
  const [ViewStationCompareData, setViewStationCompareData] = useState(null);
  const [StationComapreModal, setStationComapreModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  let controller = new AbortController();
  const signal = controller.signal;
  const handleStationCompareModal = (value) => {
    setStationComapreModal(value);
  };
  const {
    control,
    watch,
    formState: { errors },
    setValue,
  } = useForm({
    defaultValues: {
      rangeStart: "",
      rangeEnd: "",
      rangeStartCompare: "",
      rangeEndCompare: "",
    },
  });
  const handleNavigate = () => {
    setTimeout(() => {
      if (reportRef.current) {
        reportRef.current.scrollIntoView({
          behavior: "smooth",
        });
      }
    }, 100); // Delay of 100ms
  };

  const handleSetMutation = () => {
    setMutation({});
  };

  const handleDropChange = async (acceptedFiles) => {
    try {
      const isValidFile = acceptedFiles.every((file) =>
        ["pdf"].includes(file.name.split(".").pop().toLowerCase())
      );

      if (!isValidFile) {
        toast.error("Please upload a valid PDF file (.pdf).", {
          position: "top-center",
        });
        setFiles([]);
        return;
      }

      setFiles(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
    } catch (error) {
      toast.error(error?.response?.data?.message || "server error", {
        position: "top-center",
      });
    }
  };

  const handelModal = (value) => {
    setModal(value);
  };

  const handleCancel = () => {
    setFiles([]);
  };

  const handleUpload = async () => {
    setUploadButtonLoading(true);
    try {
      if (files.length === 0) {
        toast.error("Please select a file to upload.", {
          position: "top-center",
        });
        return;
      }
      const formData = new FormData();
      formData.append("transaction_report", files[0]);

      const response = await uploadPriceComparisonFileAPI(formData);

      toast.success(response?.data?.message, {
        position: "top-center",
      });
      setFiles([]);
      handleSetMutation({});
      setIsUploadingSelections(true);
      handleNavigate();
    } catch (error) {
      toast.error(error?.response?.data?.message || "server error", {
        position: "top-center",
      });
      setFiles([]);
    } finally {
      setUploadButtonLoading(false);
    }
  };

  // Sorting data
  const sortFunc = (params) => {
    if (params === "asc") {
      setSortType("asc");
    } else if (params === "dsc") {
      setSortType("desc");
    }
  };

  // onChange function for searching name
  const onFilterChange = (e) => {
    setSearchText(e.target.value);
  };

  // function which fires on applying selected action
  const onActionClick = (e) => {
    if (actionText === "suspend") {
      let newData = data?.map((item) => {
        if (item.checked === true) item.status = "Suspend";
        return item;
      });
      setData([...newData]);
    } else if (actionText === "delete") {
      let newData;
      newData = data.filter((item) => item.checked !== true);
      setData([...newData]);
    }
  };

  // function to toggle the search option
  const toggle = () => setonSearch(!onSearch);

  // Change Page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  useEffect(() => {
    // Create a debounced function for fetching the user list
    setLoading(true);
    const debouncedHandleUserList = debounce(async () => {
      try {
        const response = await fetchPriceComparisonFileAPI({
          page: currentPage,
          limit: itemPerPage,
          order: sortType,
          search: onSearchText,
          rangeStart: watch("rangeStart"),
          rangeEnd: watch("rangeEnd"),
        });
        setData(response?.data?.data?.data);
        setMetadata(response?.data?.data?.metadata);
        if (isUploadingSelections) {
          handleSelectReport(response?.data?.data?.data[0].id);
          setSelectedReport(response?.data?.data?.data[0].id);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    }, 300);

    debouncedHandleUserList();

    return () => {
      debouncedHandleUserList.cancel();
    };
  }, [
    currentPage,
    itemPerPage,
    sortType,
    onSearchText,
    mutation,
    actionText,
    watch,
    watch("rangeStart"),
    watch("rangeEnd"),
  ]);

  const rangeStart = watch("rangeStart");
  const rangeEnd = watch("rangeEnd");
  const rangeStartCompare = watch("rangeStartCompare");
  const rangeEndCompare = watch("rangeEndCompare");
  const [callingFrom, setCallingFrom] = useState("");
  // Function to convert timestamps to Date objects
  const convertToDate = (timestamp) => new Date(timestamp);

  const [maxminRangeForPricing, setMaxminRangeForPricing] = useState({
    min: null,
    max: null,
  });

  const handleSelectReport = async (id) => {
    setDisplayBlockPricingReportData(true);
    setSelectReportLoader(true);
    setCallingFrom("handleSelectReport");
    controller.abort();
    setCompareResultLoader(false);

    try {
      handleUserInfo();

      const response = await fetchComparisonData({
        id,
      });

      const { start_date, end_date, pricingFilesDatesArr } =
        response?.data?.data;

      const startDate = convertToDate(start_date);
      const endDate = convertToDate(end_date);
      const dates = pricingFilesDatesArr.map((timestamp) =>
        convertToDate(timestamp)
      );

      setMaxminRangeForPricing({
        min: startDate,
        max: endDate,
      });
      if (!response?.data?.status) {
        setErrorMessage(response?.data?.message ?? "");
      } else {
        setErrorMessage("");
        setProvidedDates(dates);
      }
      setValue("rangeStartCompare", startDate);
      setValue("rangeEndCompare", endDate);
    } catch (error) {
      console.error(error);
    } finally {
      setSelectReportLoader(false);
    }
  };

  const handlePreferencesUpdated = () => {
  if (selectedReport) {
    handleSelectReport1(selectedReport); 
  }
};

  const handleSelectReport1 = async (id) => {
    if (!id) {
      return;
    }
    setCallingFrom("handleSelectReport1");
    setPricingCalendarLoading(true);
    controller.abort();
    setCompareResultLoader(false);
    try {
      const response = await fetchComparisonData({
        id,
        rangeStart: rangeStartCompare,
        rangeEnd: rangeEndCompare,
      });

      const { pricingFilesDatesArr } = response?.data?.data;
      

      if (pricingFilesDatesArr.length <= 0) {
        return;
      }
      const dates = pricingFilesDatesArr.map((timestamp) =>
        convertToDate(timestamp)
      );

      setProvidedDates(dates);
    } catch (error) {
      console.error(error);
    } finally {
      setPricingCalendarLoading(false);
    }
  };


  useEffect(() => {
    if (callingFrom === "handleSelectReport") {
      setCallingFrom("handleSelectReport1");
      handleNavigate();
    } else {
      handleSelectReport1(selectedReport);
    }
    setDisplayBlockReportResult(false);
  }, [watch("rangeStartCompare"), watch("rangeEndCompare")]);

  const normalizeDate = (date) => {
    return new Date(date?.getFullYear(), date?.getMonth(), date?.getDate());
  };

  const isBetweenDates = (date) => {
    const normalizedDate = normalizeDate(date);
    const minDate = normalizeDate(watch("rangeStartCompare"));
    const maxDate = normalizeDate(watch("rangeEndCompare"));

    return normalizedDate >= minDate && normalizedDate <= maxDate;
  };

  const isHighlighted = (date) => {
    const normalizedDate = normalizeDate(date);
    const minDate = normalizeDate(watch("rangeStartCompare"));
    const maxDate = normalizeDate(watch("rangeEndCompare"));
    return providedDates.some((providedDate) => {
      const normalizedProvidedDate = normalizeDate(providedDate);
      return (
        normalizedProvidedDate.getDate() === normalizedDate.getDate() &&
        normalizedProvidedDate.getMonth() === normalizedDate.getMonth() &&
        normalizedProvidedDate.getFullYear() === normalizedDate.getFullYear() &&
        normalizedDate >= minDate &&
        normalizedDate <= maxDate
      );
    });
  };

  // Compare button logic
  const [compareResultDataValue, setCompareResultDataValue] = useState({});
  const [compareResultLoader, setCompareResultLoader] = useState(false);
  const handleCompareResult = async () => {
    setCompareResultLoader(true);
    try {
      const response = await compareResultData({
        id: selectedReport,
        rangeStart: rangeStartCompare,
        rangeEnd: rangeEndCompare,
        signal: signal,
      });

      const {
        lovesStation,
        pilotFlyingJStation,
        otherStations,
        stationComparisonData,
        total_saving_tsc_1,
        total_saving_tsc_2,
      } = response?.data?.data;

      if (!response?.data?.status) {
        setErrorMessage(response?.data?.message ?? "");
      } else {
        setErrorMessage("");
        setCompareResultDataValue({
          lovesStation,
          pilotFlyingJStation,
          otherStations,
        });
        setViewStationCompareData(stationComparisonData);
        setMetaDataComparisonState({
          total_saving_tsc_1,
          total_saving_tsc_2,
        });
      }
    } catch (error) {
      setErrorMessage(error?.response?.data?.message);
      console.error(error);
    } finally {
      setCompareResultLoader(false);
    }
  };

  return (
    <Content className=" h-100 pt-5">
      <Row className=" h-100 gap-2">
        <Col xs={12} lg="6" className=" h-100">
          <Block size="lg" className=" h-100">
            <PreviewCard className=" h-100 d-flex">
              <Row className="g-4">
                <Col sm="12">
                  <label className="form-label">
                    Upload New Transaction Report
                  </label>
                  <Dropzone
                    onDrop={(acceptedFiles) =>
                      handleDropChange(acceptedFiles, setFiles)
                    }
                    maxFiles={1}
                  >
                    {({ getRootProps, getInputProps }) => (
                      <section>
                        <div
                          {...getRootProps()}
                          className="dropzone upload-zone dz-clickable"
                        >
                          <input {...getInputProps()} accept=".pdf" />
                          {files?.length === 0 && (
                            <div className="dz-message">
                              <span className="dz-message-text">
                                Drag and drop Transaction Report here or click
                                to upload
                              </span>
                              <span className="dz-message-or">or</span>
                              <Button color="primary">Choose File</Button>
                            </div>
                          )}
                          {files?.map((file) => (
                            <div
                              key={file.name}
                              className="dz-preview dz-processing dz-image-preview dz-error dz-complete w-100 h-100 d-flex justify-content-center align-items-center"
                            >
                              <div>{file.name}</div>
                            </div>
                          ))}
                        </div>
                      </section>
                    )}
                  </Dropzone>
                </Col>
                <Col sm="12" md="6" lg="6">
                  <div className=" d-flex justify-content-start align-items-center gap-2">
                    <a
                      href={
                        process.env.REACT_APP_BASE_URL +
                        "public/sample-file-upload/12272024-sample-transaction-reports.pdf"
                      }
                      target="_blank"
                      rel="noreferrer"
                    >
                      Download Sample Transaction Report &nbsp;
                      <Download size={16} className=" pb-1" />
                    </a>
                  </div>
                </Col>
                {files?.length > 0 && (
                  <Col sm="12" md="6" lg="6">
                    <div className=" d-flex justify-content-end align-items-center gap-2">
                      <Button
                        disabled={uploadButtonLoading}
                        onClick={handleCancel}
                      >
                        Cancel
                      </Button>
                      <Button
                        color="primary"
                        onClick={handleUpload}
                        disabled={uploadButtonLoading}
                      >
                        {uploadButtonLoading ? <Spinner size="sm" /> : "Upload"}
                      </Button>
                    </div>
                  </Col>
                )}
              </Row>
            </PreviewCard>
          </Block>
          <Block className="px-md-0 h-100">
            <PreviewCard className=" h-100">
              <Label>Previous Comparison Reports</Label>
              <DataTable className="card-stretch">
                <div className="card-inner position-relative card-tools-toggle">
                  <div className="card-title-group">
                    <div className="card-tools">
                      <div className="form-inline flex-nowrap gx-3">
                        <div className="btn-wrap">
                          <span className="d-none">
                            <Button
                              color="light"
                              outline
                              disabled={actionText !== "" ? false : true}
                              className="btn-dim btn-icon"
                              onClick={(e) => onActionClick(e)}
                            >
                              <Icon name="arrow-right"></Icon>
                            </Button>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="card-tools me-n1 w-100 ">
                      <ul className="btn-toolbar gx-1 justify-content-end justify-content-md-between d-block d-md-none">
                        <DateRangePicker
                          control={control}
                          setValue={setValue}
                          rangeStart={rangeStart}
                          rangeEnd={rangeEnd}
                          errors={errors}
                          startLabel={"rangeStart"}
                          endLabel={"rangeEnd"}
                          isButton={true}
                        />
                      </ul>
                      <ul className="btn-toolbar gx-1 justify-content-end justify-content-md-between">
                        <div className="d-none d-md-block">
                          <DateRangePicker
                            control={control}
                            setValue={setValue}
                            rangeStart={rangeStart}
                            rangeEnd={rangeEnd}
                            errors={errors}
                            startLabel={"rangeStart"}
                            endLabel={"rangeEnd"}
                            isButton={true}
                          />
                        </div>
                        <div className="btn-toolbar gx-1">
                          <li>
                            <a
                              href="#search"
                              onClick={(ev) => {
                                ev.preventDefault();
                                toggle();
                              }}
                              className="btn btn-icon search-toggle toggle-search"
                            >
                              <Icon name="search"></Icon>
                            </a>
                          </li>
                          <li>
                            <div className="toggle-wrap">
                              <UncontrolledDropdown>
                                <DropdownToggle
                                  color="tranparent"
                                  className={`btn-icon btn-trigger dropdown-toggle ${tablesm ? "active" : ""
                                    }`}
                                >
                                  <Icon name="setting"></Icon>
                                </DropdownToggle>
                                <DropdownMenu end className="dropdown-menu-xs">
                                  <ul className="link-check">
                                    <li>
                                      <span>Show</span>
                                    </li>
                                    <li
                                      className={
                                        itemPerPage === 10 ? "active" : ""
                                      }
                                    >
                                      <DropdownItem
                                        tag="a"
                                        href="#dropdownitem"
                                        onClick={(ev) => {
                                          ev.preventDefault();
                                          setItemPerPage(10);
                                        }}
                                      >
                                        10
                                      </DropdownItem>
                                    </li>
                                    <li
                                      className={
                                        itemPerPage === 20 ? "active" : ""
                                      }
                                    >
                                      <DropdownItem
                                        tag="a"
                                        href="#dropdownitem"
                                        onClick={(ev) => {
                                          ev.preventDefault();
                                          setItemPerPage(20);
                                        }}
                                      >
                                        20
                                      </DropdownItem>
                                    </li>
                                    <li
                                      className={
                                        itemPerPage === 50 ? "active" : ""
                                      }
                                    >
                                      <DropdownItem
                                        tag="a"
                                        href="#dropdownitem"
                                        onClick={(ev) => {
                                          ev.preventDefault();
                                          setItemPerPage(50);
                                        }}
                                      >
                                        50
                                      </DropdownItem>
                                    </li>
                                  </ul>
                                  <ul className="link-check">
                                    <li>
                                      <span>Order</span>
                                    </li>
                                    <li
                                      className={sort === "dsc" ? "active" : ""}
                                    >
                                      <DropdownItem
                                        tag="a"
                                        href="#dropdownitem"
                                        onClick={(ev) => {
                                          ev.preventDefault();
                                          setSortState("dsc");
                                          sortFunc("dsc");
                                        }}
                                      >
                                        DESC
                                      </DropdownItem>
                                    </li>
                                    <li
                                      className={sort === "asc" ? "active" : ""}
                                    >
                                      <DropdownItem
                                        tag="a"
                                        href="#dropdownitem"
                                        onClick={(ev) => {
                                          ev.preventDefault();
                                          setSortState("asc");
                                          sortFunc("asc");
                                        }}
                                      >
                                        ASC
                                      </DropdownItem>
                                    </li>
                                  </ul>
                                </DropdownMenu>
                              </UncontrolledDropdown>
                            </div>
                          </li>
                        </div>
                      </ul>
                    </div>
                  </div>
                  <div
                    className={`card-search search-wrap ${!onSearch && "active"
                      }`}
                  >
                    <div className="card-body">
                      <div className="search-content">
                        <Button
                          className="search-back btn-icon toggle-search active"
                          onClick={() => {
                            setSearchText("");
                            toggle();
                          }}
                        >
                          <Icon name="arrow-left"></Icon>
                        </Button>
                        <input
                          type="text"
                          className="border-transparent form-focus-none form-control"
                          placeholder="Search by Transaction Report name"
                          value={onSearchText}
                          onChange={(e) => onFilterChange(e)}
                        />
                        <Button className="search-submit btn-icon">
                          <Icon name="search"></Icon>
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
                <DataTableBody>
                  <DataTableHead>
                    <DataTableRow size="xs">
                      <span className="sub-text">File Name</span>
                    </DataTableRow>
                    <DataTableRow className="nk-tb-col-tools text-end"></DataTableRow>
                  </DataTableHead>
                  {/*Head*/}
                  {loading ? (
                    <tr>
                      <td colSpan="100%">
                        <div
                          className="d-flex justify-content-center align-items-center"
                          style={{ height: "100px", width: "100%" }} // Full height and width
                        >
                          <Spinner color="primary" />
                        </div>
                      </td>
                    </tr>
                  ) : (
                    <>
                      {data?.length > 0
                        ? data?.map((item) => {
                          return (
                            <DataTableItem
                              key={item.id}
                              className={` h-100 ${selectedReport === item?.id
                                ? "bg-gray-100"
                                : ""
                                }`}
                            >
                              <DataTableRow size="xs" className="py-1">
                                {/* For smaller screens */}
                                <span className="d-block d-md-none">
                                  {item?.original_file_name?.length > 50
                                    ? item?.original_file_name?.substring(
                                      0,
                                      50
                                    ) + "..."
                                    : item?.original_file_name}
                                </span>
                                <span className="d-none d-md-block">
                                  {item?.original_file_name}
                                </span>
                              </DataTableRow>
                              <DataTableRow
                                className={`d-flex justify-content-end `}
                              >
                                <ul className="nk-tb-actions gx-1">
                                  <li className="nk-tb-action-hidden">
                                    <TooltipComponent
                                      tag="a"
                                      containerClassName="btn btn-trigger btn-icon"
                                      id={"download" + item.id}
                                      icon="download"
                                      direction="top"
                                      text="Download"
                                      href={
                                        process.env.REACT_APP_BASE_URL +
                                        "public/uploads/reports/" +
                                        item.file_name
                                      }
                                      download={item.original_filename}
                                      target="_blank"
                                    />
                                  </li>
                                  <li>
                                    <Button
                                      color={
                                        selectedReport === item?.id
                                          ? "primary"
                                          : "secondary"
                                      }
                                      className="btn-round pe-3 py-1"
                                      onClick={() => {
                                        setSelectedReport(item?.id);
                                        handleSelectReport(item?.id);
                                        setDisplayBlockReportResult(false);
                                      }}
                                      disabled={selectedReport === item?.id}
                                    >
                                      {selectedReport === item?.id
                                        ? "Selected"
                                        : "Select"}
                                    </Button>
                                  </li>
                                </ul>
                              </DataTableRow>
                            </DataTableItem>
                          );
                        })
                        : null}
                    </>
                  )}
                </DataTableBody>
                <div className="card-inner">
                  {data?.length > 0 ? (
                    <PaginationComponent
                      itemPerPage={itemPerPage}
                      totalItems={metadata?.totalRecords}
                      paginate={paginate}
                      currentPage={currentPage}
                    />
                  ) : (
                    <div className="text-center">
                      <span className="text-silent">No data found</span>
                    </div>
                  )}
                </div>
              </DataTable>
            </PreviewCard>
          </Block>
        </Col>
        <Col>
          <div ref={reportRef}>
            {displayBlockPricingReportData ? (
              <Col>
                <Block size="lg">
                  <PreviewCard className=" d-flex h-100 w-100 justify-content-center align-items-center">
                    {selectReportLoader ? (
                      <Spinner color="primary" />
                    ) : (
                      <>
                        <Row className="g-2">
                          <Col xs={12} md={12} lg={12} xl={6}>
                            <Row className="g-2 h-100">
                              <Col xs={12} className=" ">
                                <Card className="border pb-2 h-100">
                                  <CardHeader
                                    tag="h5"
                                    className="bg-light text-dark "
                                  >
                                    <label className="">
                                      Transaction Report
                                    </label>
                                    <p className="text-base pt-1 fs-10px">
                                      {data?.find(
                                        (item) => item?.id === selectedReport
                                      )?.original_file_name ||
                                        "No file selected"}
                                    </p>
                                  </CardHeader>

                                  <li className="btn-toolbar-sep d-flex py-3 border-0">
                                    <DateRangePicker
                                      displayOnMobile={true}
                                      control={control}
                                      setValue={setValue}
                                      rangeStart={rangeStartCompare}
                                      rangeEnd={rangeEndCompare}
                                      errors={errors}
                                      startLabel={"rangeStartCompare"}
                                      endLabel={"rangeEndCompare"}
                                      minDate={maxminRangeForPricing.min}
                                      maxDate={maxminRangeForPricing.max}
                                    />
                                  </li>
                                </Card>
                              </Col>
                              <Col xs={12} md={12} className="h-50">
                                <Card className="border-light border w-100 h-100">
                                  <CardHeader
                                    className=" d-flex justify-content-between w-100 align-items-center bg-light text-dark"
                                    tag="h5"
                                  >
                                    <div>Compare Preferences</div>
                                    <Icon
                                      style={{ cursor: "pointer" }}
                                      name="edit-alt-fill"
                                      onClick={() => handelModal(true)}
                                    ></Icon>
                                  </CardHeader>
                                  <CardBody>
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                      <div>Cost Plus Value:</div>
                                      <div style={{ fontWeight: "bold" }}>
                                        {formatCurrency(
                                          defaultValuesGlobal?.costPlus
                                        )}
                                      </div>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                      <div>Distance Radius:</div>
                                      <div style={{ fontWeight: "bold" }}>
                                        {defaultValuesGlobal?.distanceRadius} Miles
                                      </div>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                      <div>State Fallback:</div>
                                      <div style={{ fontWeight: "bold" }}>
                                        {defaultValuesGlobal?.stateFallback ===
                                          1
                                          ? "On"
                                          : "Off"}
                                      </div>
                                    </div>

                                    <div className="d-flex justify-content-between align-items-center mb-2 pb-3">
                                      <div>Station Type</div>
                                      <div style={{ fontWeight: "bold" }}>
                                        {defaultValuesGlobal?.selectPetro == "ta_petro" ? "TA Petro" : defaultValuesGlobal?.selectPetro == "loves" ? "Loves" : defaultValuesGlobal?.selectPetro}
                                      </div>
                                    </div>

                                  </CardBody>
                                </Card>
                              </Col>
                            </Row>
                          </Col>
                          <Col
                            xs={12}
                            md={12}
                            lg={12}
                            xl={6}
                            className="h-100 pt-4 pt-xl-0"
                          >
                            <Row className="g-0 h-100">
                              <Col xs={12} className=" h-100">
                                <Card className="border ">
                                  <CardHeader
                                    tag="h5"
                                    className="bg-light text-dark "
                                  >
                                    <label className="">
                                      Available Pricing Files
                                    </label>
                                  </CardHeader>
                                  <div
                                    className="d-flex flex-wrap m-2 rounded-2 h-100 justify-content-center align-items-center "
                                    style={{ minHeight: "250px" }}
                                  >
                                    {pricingCalendarLoading ? (
                                      <Spinner color="primary" />
                                    ) : (
                                      <Calendar
                                        value={[maxminRangeForPricing.max]}
                                        minDate={watch("rangeStartCompare")}
                                        maxDate={watch("rangeEndCompare")}
                                        locale="en-US"
                                        tileClassName={({ date }) => {
                                          if (isHighlighted(date)) {
                                            return "highlighted-date"; // Custom class for highlighted dates
                                          }
                                          if (isBetweenDates(date)) {
                                            return "between-date"; // Custom class for dates between the range
                                          }
                                          return null;
                                        }}
                                      />
                                    )}
                                  </div>
                                </Card>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <div className="h-100 d-flex justify-content-center align-items-center pt-4">
                              <Button
                                color="primary"
                                className="px-4"
                                onClick={() => {
                                  if (providedDates.length > 0) {
                                    setDisplayBlockReportResult(true);
                                    handleCompareResult();
                                  } else {
                                    setDisplayBlockReportResult(true);
                                    setCompareResultDataValue({});
                                    setViewStationCompareData(null);
                                    setMetaDataComparisonState({});
                                  }
                                }}
                                disabled={compareResultLoader}
                              >
                                Compare
                              </Button>
                            </div>
                          </Col>
                        </Row>
                      </>
                    )}
                  </PreviewCard>
                </Block>
                {displayBlockReportResult && (
                  <>
                    <Block className="">
                      {compareResultLoader ? (
                        <Card className="h-100 d-flex justify-content-center align-items-center p-4">
                          <Spinner color="primary" />
                        </Card>
                      ) : (
                        <div>
                          {errorMessage && (
                            <div
                              class="alert alert-danger d-block my-2"
                              role="alert"
                            >
                              {errorMessage}
                            </div>
                          )}
                          {!errorMessage && (
                            <Card className="shadow-sm mb-4">
                              <CardHeader
                                tag="h5"
                                className="bg-light text-dark text-center"
                              >
                                Comparison Result
                              </CardHeader>
                              <CardBody>
                                <Row className="g-4">
                                  {/* Loves Section */}
                                  <Col xs={12} md={12} lg={12} xl={6}>
                                    <Card className="border-light">
                                      <CardHeader
                                        tag="h6"
                                        className="bg-light text-dark"
                                      >
                                        {compareResultDataValue
                                          ?.lovesStation?.name}
                                      </CardHeader>
                                      <CardBody>
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                          <div>
                                            Total Saving at Cost Plus Value
                                            Entered:
                                          </div>
                                          <div
                                            style={{
                                              fontWeight: "bold",
                                              wordBreak: "keep-all",
                                            }}
                                          >
                                            {formatCurrency(
                                              compareResultDataValue
                                                ?.lovesStation
                                                ?.totalSavingAmount
                                            ) ?? "0.0000"}
                                          </div>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                          <div>
                                            Savings per gallon at Cost Plus
                                            Value Entered:
                                          </div>
                                          <div
                                            style={{
                                              fontWeight: "bold",
                                              wordBreak: "keep-all",
                                            }}
                                          >
                                            {formatCurrency(
                                              compareResultDataValue
                                                ?.lovesStation
                                                ?.totalSavingPerGallonAmountNew
                                            ) ?? "0.0000"}
                                          </div>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                          <div>
                                            Average Price per gallon at Cost
                                            Plus Value Entered:
                                          </div>
                                          <div
                                            style={{
                                              fontWeight: "bold",
                                              wordBreak: "keep-all",
                                            }}
                                          >
                                            {formatCurrency(
                                              compareResultDataValue
                                                ?.lovesStation
                                                ?.avgPricePerGallonCostValueEntered
                                            ) ?? "0.0000"}
                                            /gallon
                                          </div>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center">
                                          <div>
                                            Break-even point at Cost Plus Price:
                                          </div>
                                          <div
                                            style={{
                                              fontWeight: "bold",
                                              wordBreak: "keep-all",
                                            }}
                                          >
                                            {formatCurrency(
                                              compareResultDataValue
                                                ?.lovesStation
                                                ?.breakEvenPointCostValuePrice
                                            ) ?? "0.0000"}
                                            /gallon
                                          </div>
                                        </div>
                                      </CardBody>
                                    </Card>
                                  </Col>

                                  {/* PFJ Section */}
                                  <Col xs={12} md={12} lg={12} xl={6}>
                                    <Card className="border-light">
                                      <CardHeader
                                        tag="h6"
                                        className="bg-light text-dark"
                                      >
                                        Pilot Flying J
                                      </CardHeader>
                                      <CardBody>
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                          <div>
                                            Total Saving at Cost Plus Value
                                            Entered:
                                          </div>
                                          <div
                                            style={{
                                              fontWeight: "bold",
                                              wordBreak: "keep-all",
                                            }}
                                          >
                                            {formatCurrency(
                                              compareResultDataValue
                                                ?.pilotFlyingJStation
                                                ?.totalSavingAmount
                                            ) ?? "0.0000"}
                                          </div>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                          <div>
                                            Savings per gallon at Cost Plus
                                            Value Entered:
                                          </div>
                                          <div
                                            style={{
                                              fontWeight: "bold",
                                              wordBreak: "keep-all",
                                            }}
                                          >
                                            {formatCurrency(
                                              compareResultDataValue
                                                ?.pilotFlyingJStation
                                                ?.totalSavingPerGallonAmountNew
                                            ) ?? "0.0000"}
                                          </div>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                          <div>
                                            Average Price per gallon at Cost
                                            Plus Value Entered:
                                          </div>
                                          <div
                                            style={{
                                              fontWeight: "bold",
                                              wordBreak: "keep-all",
                                            }}
                                          >
                                            {formatCurrency(
                                              compareResultDataValue
                                                ?.pilotFlyingJStation
                                                ?.avgPricePerGallonCostValueEntered
                                            ) ?? "0.0000"}
                                            /gallon
                                          </div>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center">
                                          <div>
                                            Break-even point at Cost Plus Price:
                                          </div>
                                          <div
                                            style={{
                                              fontWeight: "bold",
                                              wordBreak: "keep-all",
                                            }}
                                          >
                                            {formatCurrency(
                                              compareResultDataValue
                                                ?.pilotFlyingJStation
                                                ?.breakEvenPointCostValuePrice
                                            ) ?? "0.0000"}
                                            /gallon
                                          </div>
                                        </div>
                                      </CardBody>
                                    </Card>
                                  </Col>

                                  {/* Others Section */}
                                  <Col xs={12} md={12} lg={12} xl={12}>
                                    <Card className="border-light">
                                      <CardHeader
                                        tag="h6"
                                        className="bg-light text-dark"
                                      >
                                        Others
                                      </CardHeader>
                                      <CardBody>
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                          <div>
                                            Total Saving at Cost Plus Value
                                            Entered:
                                          </div>
                                          <div
                                            style={{
                                              fontWeight: "bold",
                                              wordBreak: "keep-all",
                                            }}
                                          >
                                            {formatCurrency(
                                              compareResultDataValue
                                                ?.otherStations
                                                ?.totalSavingAmount
                                            ) ?? "0.0000"}
                                          </div>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                          <div>
                                            Savings per gallon at Cost Plus
                                            Value Entered:
                                          </div>
                                          <div
                                            style={{
                                              fontWeight: "bold",
                                              wordBreak: "keep-all",
                                            }}
                                          >
                                            {formatCurrency(
                                              compareResultDataValue
                                                ?.otherStations
                                                ?.totalSavingPerGallonAmountNew
                                            ) ?? "0.0000"}
                                          </div>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                          <div>
                                            Average Price per gallon at Cost
                                            Plus Value Entered:
                                          </div>
                                          <div
                                            style={{
                                              fontWeight: "bold",
                                              wordBreak: "keep-all",
                                            }}
                                          >
                                            {formatCurrency(
                                              compareResultDataValue
                                                ?.otherStations
                                                ?.avgPricePerGallonCostValueEntered
                                            ) ?? "0.0000"}
                                            /gallon
                                          </div>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center">
                                          <div>
                                            Break-even point at Cost Plus Price:
                                          </div>
                                          <div
                                            style={{
                                              fontWeight: "bold",
                                              wordBreak: "keep-all",
                                            }}
                                          >
                                            {formatCurrency(
                                              compareResultDataValue
                                                ?.otherStations
                                                ?.breakEvenPointCostValuePrice
                                            ) ?? "0.0000"}
                                            /gallon
                                          </div>
                                        </div>
                                      </CardBody>
                                    </Card>
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          )}
                          {!errorMessage && (
                            <Row>
                              <Col className=" w-100 d-flex justify-content-center">
                                <Button
                                  color={"primary"}
                                  onClick={() =>
                                    handleStationCompareModal(true)
                                  }
                                >
                                  View Station Comparison
                                </Button>
                              </Col>
                            </Row>
                          )}
                        </div>
                      )}
                    </Block>
                  </>
                )}
              </Col>
            ) : (
              <Col>
                <Block size="lg" className=" d-flex w-100 h-100">
                  <PreviewCard className="d-flex w-100 h-100">
                    <h4 className="font-bold text-xl mb-2">Instructions</h4>
                    <p className="text-base">
                      1. Upload the Transaction Report PDF.
                    </p>
                    <p className="text-base">
                      2. Select the report once it has been processed.
                    </p>
                    <p className="text-base">
                      3. Review the dates to ensure the XLS data is available.
                    </p>
                    <p className="text-base">
                      4. Adjust the date range as desired.
                    </p>
                    <p className="text-base">
                      5. Edit the cost-plus value as desired.
                    </p>
                    <p className="text-base">
                      6. Click the Compare button to process and view the
                      results.
                    </p>
                  </PreviewCard>
                </Block>
              </Col>
            )}
          </div>
        </Col>
      </Row>
      <CostPlusEditModal
        modalForm={modal}
        setModalForm={handelModal}
        userData={{
          setMutationCall: handleSetMutation,
        }}
        isComparePage={true}
        selectedReport={selectedReport}
        setMaxminRangeForPricing={setMaxminRangeForPricing}
        setSelectReportLoader={setSelectReportLoader}
        setErrorMessage={setErrorMessage}
        setProvidedDates={setProvidedDates}
        setValue={setValue}
        onPreferencesUpdate={handlePreferencesUpdated} 
        updateCostPlus={false}
      />
      {ViewStationCompareData && (
        <ViewStationCompareModal
          modalForm={StationComapreModal}
          setModalForm={handleStationCompareModal}
          ViewStationCompareData={ViewStationCompareData ?? []}
          metaDataComparisonState={metaDataComparisonState}
        />
      )}
    </Content>
  );
};

export default Index;
